export default {
    list: {
        title: "Companies",
        subtitle: "Manage international companies",
        newCompany: "New Company",
        loading: "Loading companies...",
        filters: {
            searchPlaceholder: "Search by name, email, tax ID...",
            statusPlaceholder: "Filter by status",
            companyTypePlaceholder: "Filter by company type",
            countryPlaceholder: "Filter by country",
            allTypes: "All types",
            allStatuses: "All statuses",
            allCountries: "All countries",
            companyTypes: {
                sender: "Shipper",
                receiver: "Receiver",
                freightForwarder: "Freight Forwarder",
                carrier: "Carrier",
                customsBroker: "Customs Broker",
                portAuthority: "Port Authority",
                insuranceProvider: "Insurance Provider",
            },
        },
        table: {
            title: "Companies",
            description: "Complete list of companies",
            headers: {
                companyType: "Company Type",
                companyName: "Company Name",
                legalName: "Legal Name",
                country: "Country",
                status: "Status",
                createdAt: "Creation Date",
                actions: "Actions",
            },
            edit: "Edit",
            manageTeam: "Team",
            menuConfig: "Config",
            noCompanies: {
                title: "No companies found",
                message: "Try modifying the search filters",
                emptyMessage: "Start by creating your first company",
                createFirst: "Create the first company",
            },
        },
        status: {
            active: "Active",
            suspended: "Suspended",
            inactive: "Inactive",
        },
        confirmDelete: "Are you sure you want to delete this company?",
    },
    form: {
        edit: {
            title: "Edit Company",
            subtitle: "Edit company details",
        },
        create: {
            title: "New Company",
            subtitle: "Create a new company",
        },
        loading: "Loading company...",
        back: "Back",
        sections: {
            general: "General Information",
            address: "Address",
            contacts: "Contacts",
            notes: "Additional Notes",
        },
        stepper: {
            step1: {
                title: "Company Info",
                description: "Basic company information and legal details",
            },
            step2: {
                title: "Team Management",
                description: "Add team members who can access the platform",
                roles: {
                    operator: "Operator",
                    companyAdmin: "Company Admin",
                },
                fields: {
                    email: "Email",
                    emailPlaceholder: "name@company.com",
                    firstName: "First Name",
                    firstNamePlaceholder: "Enter first name",
                    lastName: "Last Name",
                    lastNamePlaceholder: "Enter last name",
                    role: "Role",
                    rolePlaceholder: "Select role",
                },
                addMember: "Add Team Member",
                addButton: "Add",
                remove: "Remove",
                membersList: "Team Members",
                noMembers: "No team members added. You can add them after creating the company.",
                duplicateEmail: "This email has already been added to the team",
            },
        },
        fields: {
            companyType: "Company Type",
            companyTypePlaceholder: "Select company type",
            companyTypes: {
                sender: "Shipper",
                receiver: "Receiver",
                freightForwarder: "Freight Forwarder",
                carrier: "Carrier",
                customsBroker: "Customs Broker",
                portAuthority: "Port Authority",
                insuranceProvider: "Insurance Provider",
            },
            companyName: "Company Name",
            companyNamePlaceholder: "Enter company name",
            legalName: "Legal Name",
            legalNamePlaceholder: "Enter legal name",
            entityType: "Entity Type",
            entityTypePlaceholder: "Select entity type",
            taxId: "Tax ID",
            taxIdPlaceholder: "Enter tax ID",
            status: "Status",
            statusPlaceholder: "Select status",
            street: "Street",
            streetPlaceholder: "Enter full address",
            city: "City",
            cityPlaceholder: "Enter city",
            state: "State/Province",
            statePlaceholder: "Enter state or province",
            postalCode: "Postal Code",
            postalCodePlaceholder: "Enter postal code",
            country: "Country",
            countryPlaceholder: "Select country",
            email: "Email",
            emailPlaceholder: "name@company.com",
            phone: "Phone",
            phonePlaceholder: "+1 123 456 7890",
            notes: "Notes",
            notesPlaceholder: "Enter additional notes about the company...",
        },
        actions: {
            cancel: "Cancel",
            save: "Save Changes",
            create: "Create Company",
            next: "Next",
            back: "Back",
            previous: "Previous",
            menuConfig: "Menu Configuration",
        },
        saving: "Saving company...",
        creating: "Creating company...",
    },
    team: {
        title: "{{companyName}} Team",
        subtitle: "Manage team members and pending invitations",
        loading: "Loading team...",
        errorLoading: "Error loading team data",
        companyNotFound: "Company not found",
        backToCompanies: "Back to Companies",
        addMember: "Add Member",
        activeMembers: "Active Members",
        activeMembersDescription: "Active users with platform access",
        pendingInvitations: "Pending Invitations",
        pendingInvitationsDescription: "Email invitations awaiting acceptance",
        noActiveMembers: "No active members",
        roles: {
            superAdmin: "Super Admin",
            companyAdmin: "Company Admin",
            operator: "Operator",
            viewer: "Viewer",
        },
        status: {
            active: "Active",
            inactive: "Inactive",
            pending: "Pending",
            expired: "Expired",
        },
        table: {
            headers: {
                name: "Name",
                email: "Email",
                role: "Role",
                status: "Status",
                joinedAt: "Joined",
                invitedAt: "Invited",
                expiresAt: "Expires",
            },
        },
        form: {
            email: "Email",
            emailPlaceholder: "member@example.com",
            firstName: "First Name",
            firstNamePlaceholder: "John",
            lastName: "Last Name",
            lastNamePlaceholder: "Doe",
            role: "Role",
            activationMethod: "Activation method",
            activationMethods: {
                emailInvitation: "Email invitation",
                directActivation: "Direct activation by admin",
            },
            password: "Password",
            passwordPlaceholder: "Enter password (min 8 characters)",
            passwordConfirm: "Confirm password",
            passwordConfirmPlaceholder: "Confirm password",
            addButton: "Add Member",
            addingMember: "Adding team member...",
        },
        error: {
            emailRequired: "Email is required",
            passwordRequired: "Password and password confirmation are required",
            passwordMinLength: "Password must be at least 8 characters long",
            passwordMismatch: "Password and password confirmation do not match",
            addingMember: "Error adding team member",
            updatingMember: "Error updating team member",
            removingMember: "Error removing team member",
            resendingInvitation: "Error resending invitation",
        },
        success: {
            memberAdded: "Team member added successfully",
            memberInvitationSent: "Invitation email sent successfully",
            memberCreatedDirect: "User created and activated successfully",
            memberUpdated: "Team member updated successfully",
            memberRemoved: "Team member removed successfully",
            invitationResent: "Invitation email resent successfully",
        },
        actions: {
            edit: "Edit",
            remove: "Remove",
            resend: "Resend",
        },
        editMember: {
            title: "Edit Team Member",
            name: "Name",
            email: "Email",
            isActive: "Active",
            saveButton: "Save Changes",
        },
        removeMember: {
            title: "Remove Team Member",
            confirmation: "Are you sure you want to remove {{name}} ({{email}}) from this company?",
            sendNotificationEmail: "Send notification email to the user",
            confirmButton: "Remove Member",
        },
        resetData: {
            menuItem: "Reset Data",
            title: "Reset User Data",
            warning: "This will permanently delete all operational data for this user's company. User and company entities will be preserved.",
            mode: "Execution Mode",
            dryRun: "Dry Run (preview only)",
            force: "Force (delete data)",
            deleteEmails: "Also delete emails",
            deleteEmailsHint: "By default emails are preserved and reset for reprocessing. Enable only if you want to re-sync from the provider.",
            run: "Run",
            running: "Running...",
            completed: "Completed",
            error: "Error occurred",
            close: "Close",
        },
    },
    menuConfig: {
        title: "Menu Configuration",
        subtitle: "Configure menu items for {{companyName}}",
        back: "Back to Company",
        backToCompanies: "Back to Companies",
        companyNotFound: "Company not found",
        loading: "Loading menu configuration...",
        override: {
            title: "Menu Configuration Override",
            descriptionHasOverride: "This company has a custom menu configuration. Changes here will override the global settings.",
            descriptionNoOverride: "This company uses the global menu configuration. Enable override to customize menu items for this company only.",
            deleteButton: "Delete Override",
            deleteConfirm: "Are you sure you want to delete the menu override? The company will use the global configuration.",
            deleteSuccess: "Menu override deleted successfully",
            deleteError: "Failed to delete menu override",
            saveButton: "Save Override",
            saving: "Saving...",
            saveSuccess: "Menu override saved successfully",
            saveError: "Failed to save menu override",
            resetButton: "Reset",
            loading: "Loading configuration...",
            noItems: "No menu items available for this company type",
            alwaysEnabled: "Always Enabled",
            key: "Key",
            badge: "Override",
        },
    },
};
